/* eslint-disable react/no-danger */
import React, { FC } from 'react';
import { Image } from '@design-system/image';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { NavigationOptions } from 'swiper/types';

import { customHistoryCarouselMockedData } from './customHistoryCarouselMockedData';
import { ICustomHistoryCarousel } from './models';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

SwiperCore.use([Navigation, Pagination]);

const CustomHistoryCarousel: FC<ICustomHistoryCarousel> = ({ variant }) => {
  const data = customHistoryCarouselMockedData[variant];

  return (
    <div className="custom-history-carousel">
      <div className="custom-history-carousel__nav">
        <button
          type="button"
          className="swiper-button-prev custom-prev"
          aria-label="Diapositiva anterior"
        />

        <button
          type="button"
          className="swiper-button-next custom-next"
          aria-label="Siguiente diapositiva"
        />
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={0}
        navigation={{
          prevEl: '.custom-prev',
          nextEl: '.custom-next',
        }}
        onBeforeInit={(swiper) => {
          const navigation = swiper.params.navigation as NavigationOptions;

          navigation.prevEl = '.custom-prev';
          navigation.nextEl = '.custom-next';
        }}
        pagination={{
          clickable: true,
          renderBullet: (
            index,
            className
          ) => `<button class="${className} custom-history-carousel__bullet">
                      ${data[index].year}
                    </button>`,
        }}
        className="custom-history-carousel__swiper"
      >
        {data.map(({ image, year, text }) => (
          <SwiperSlide key={year}>
            <div className="custom-history-carousel__card">
              <Image
                src={image.src}
                alt={image.altText}
                className="custom-history-carousel__image"
              />
              <div className="custom-history-carousel__text-content">
                <h2 className="custom-history-carousel__year">{year}</h2>
                <h4
                  className="custom-history-carousel__text"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CustomHistoryCarousel;
